import * as v from 'valibot';
import { endpointIdSchema, groupIdSchema, hasExactKeys, ieeeSchema, nwkSchema } from '../../util/valibot';
export const addressGroupSchema = v.object({
    group: groupIdSchema
});
export const addressNWKSchema = v.object({
    nwk: nwkSchema,
    endpoint: v.optional(endpointIdSchema),
});
export const addressIEEESchema = v.object({
    ieee: ieeeSchema,
    endpoint: v.optional(endpointIdSchema),
});
export const addressNWKIEEESchema = v.object({
    nwk: nwkSchema,
    ieee: ieeeSchema,
    endpoint: v.optional(endpointIdSchema),
});
export const addressSchema = v.lazy((s) => {
    if (hasExactKeys(addressGroupSchema, s)) {
        return addressGroupSchema;
    }
    else if (hasExactKeys(addressNWKSchema, s)) {
        return addressNWKSchema;
    }
    else if (hasExactKeys(addressIEEESchema, s)) {
        return addressIEEESchema;
    }
    else if (hasExactKeys(addressNWKIEEESchema, s)) {
        return addressNWKIEEESchema;
    }
    else {
        return v.never('Expected an Address');
    }
});
export function isAddressGroup(obj) {
    return 'group' in obj && typeof obj.group === 'number';
}
export function isAddressIEEE(obj) {
    return 'ieee' in obj && typeof obj.ieee === 'string' && !('nwk' in obj) && !('group' in obj);
}
export function isAddressNWK(obj) {
    return 'nwk' in obj && typeof obj.nwk === 'number' && !('group' in obj) && !('ieee' in obj);
}
export function isAddressNWKIEEE(obj) {
    return 'nwk' in obj && typeof obj.nwk === 'number' && 'ieee' in obj && typeof obj.ieee === 'string';
}
